{
  "lang": "nl",
  "theme": "rijks-ics",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "cogs",
    "continuelink",
    "control-filter",
    "custom-radios",
    "end-tools",
    "hacks:label-quotable",
    "headings",
    "history",
    "legacy",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "metadata-scoring",
    "metaprogress",
    "mis-click-count",
    "nonce-metatag",
    "noscript",
    "nta:disclaimer-link",
    "nta:dynamic-menu-items",
    "nta:mopinion",
    "nta:path-to-modelname",
    "nta:piwik-nonce",
    "nta:proxymap",
    "nta:rijksoverheidshuisstijlfonts",
    "questionlabelgroup-ng",
    "rijks-ncsc:footer"
  ],
  "overrideinloghtml": "ics.html",
  "arbitrary": {
    "core": {
      "scrollToSelectedGroup": false
    },
    "mopinion": {
     "pastease.js": "https://survey-deploy.platformrijksoverheid.nl/js/pastease.js",
       "ics": {
        "id": "Dyd2yvA2XWPnhhP5QEC52MBtoSxj9PjFNYzDapFf"
      }
    },
    "piwik": {
      "fallback": {
        "code": "9523ffd3-87c5-41bb-9f98-8278d8f79be2",
        "endpoint": "//statistiek.rijksoverheid.nl/containers/"
      }
    },
    "proxymap": {
      "security-check-procesautomatisering": {
        "modelname": "ics"
      }
    },
    "noscript": {
      "linkstext": "Deze regelhulp vereist JavaScript. Volg, om de regelhulp op een browser zonder JavaScript te doen, een van de volgende links.",
      "links": [
        {
          "url": "open?modelname=ics",
          "description": "ICS"
        }
      ]
    },
    "legacy": {
      "notice": "<h1>Sorry :(</h1>Deze online tool vereist een moderne browser.<br/>Ondersteunde browsers zijn in ieder geval: <ul><li>Laatste (3) versies van Chrome<li>Firefox, huidige ESR (78.15.0esr) of hoger,<li>Chromium-based Edge (vanaf versie 80)<li>Safari versie 13.1 op OSX</ul>Er wordt gewerkt aan support voor Safari op iOS.<br>Internet Explorer en oude Microsoft Edge (tot en met versie 18) worden <strong>niet</strong> ondersteund.<br>Oh, en JavaScript moet aanstaan."
    },
    "end-tools": {
      "block": [
        "email"
      ]
    },
    "history": {
      "keepParams": [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_uid"
      ]
    }
  },
  "template": {
    "title": "Security Check Procesautomatisering",
    "seo": {
      "description": "Zelfscan voor de veiligheid van je ICS en OT-apparaten",
      "canonical": "https://tools.ncsc.nl/security-check-procesautomatisering/"
    },
    "logo-link": "https://www.ncsc.nl/",
    "restart-link": "https://tools.ncsc.nl/security-check-procesautomatisering/",
    "readonly-prop": "disabled"
  },
  "legacy": false
}
